export default {
  GET_CLASSIFICATION_BY_NODE: 'getClassificationByNode',
  GET_CLASSIFICATION_RECURSIVE_BY_NODE: 'getClassificationRecursiveByNode',
  SIMULATE_MARKS_PERMISSION: 'simulateMarksPermission',
  SAVE_SECURITY_CLASSIFICATION: 'saveSecurityClassification',
  SAVE_SECURITY_CLASSIFICATION_PER_NODE: 'saveSecurityClassificationPerNode',
  CLEAR_SECURITY_CLASSIFICATION_PER_NODE: 'clearSecurityClassificationPerNode'
}
